import React, { useState } from "react";
import "../../styles/navBar.css";
import useIsMobile from "../isMobile/IsMobile";
import logo from "../../assets/images/logo1.png";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile(768);

  const navItems = [
    { name: "Home", link: "/" },
    { name: "About Us", link: "/about" },
    { name: "Courses", link: "/courses" },
  ];

  return (
    <nav className="navbar">
      {/* Logo */}
       <a href="/">
      <div className="navbar-logo">
       
        <img src={logo} alt="Logo" className="logo-img" />
        <span className="logo-text">Little Learner</span>
       
      </div>
       </a>

      {/* Desktop Menu */}
      {!isMobile && (
        <div className="nav-items">
          {navItems.map((item, idx) => (
            <a
              key={idx}
              href={item.link}
              className="nav-link"
            >
              {item.name}
            </a>
          ))}
         <a href="tel:8531966231">
      <button className="gradient-btn">Book a Demo</button>
    </a>
        </div>
      )}

      {/* Mobile Menu Button */}
      {isMobile && (
        <button
          className={`menu-toggle ${isMobileMenuOpen ? "open" : ""}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      )}

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          {navItems.map((item, idx) => (
            <a
              key={idx}
              href={item.link}
              className="mobile-link"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.name}
            </a>
          ))}
         <a href="tel:8531966231">
      <button
        className="gradient-btn"
        style={{ marginTop: 20 }}
        onClick={() => setIsMobileMenuOpen(false)}
      >
        Book a Demo
      </button>
    </a>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
